<!-- SubscriptionResult.vue -->

<template>
  <div class="text-center p-6 flex flex-col items-center justify-center">
    <!-- Estado de Sucesso -->
    <div v-if="result.success">
      <div
        class="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-green-100"
      >
        <svg
          class="h-8 w-8 text-green-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <h3 class="mt-5 text-2xl font-semibold text-[color:var(--text-dark)]">
        Pagamento Aprovado!
      </h3>
      <p class="mt-3 text-lg text-[color:var(--text-light)] whitespace-pre-line">
        {{ result.message }}
      </p>
      <div class="mt-10 w-full">
        <button
          @click="emit('complete')"
          type="button"
          class="w-full inline-flex items-center justify-center rounded-lg px-6 py-4 text-lg font-semibold bg-[var(--bg-sidebar-left)] text-[color:var(--text-dark)] transition hover:opacity-90"
        >
          Ir para o Litterae!
        </button>
      </div>
    </div>

    <!-- Estado de Falha -->
    <div v-else>
      <div
        class="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red-100"
      >
        <svg
          class="h-8 w-8 text-red-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </div>
      <h3 class="mt-5 text-2xl font-semibold text-[color:var(--text-dark)]">
        Não foi possível concluir o pagamento
      </h3>
      <p class="mt-3 text-lg text-[color:var(--text-light)]">
        {{ result.message }}
      </p>

      <div class="mt-10 w-full space-y-4">
        <!-- 1) Tentar novamente (roxo primário) -->
        <button
          @click="emit('retry')"
          type="button"
          class="w-full inline-flex items-center justify-center rounded-lg px-6 py-4 text-lg font-semibold text-[#2a2457] bg-[var(--brand-light)] transition hover:bg-[var(--brand-hover)]"
        >
          Tentar novamente
        </button>

        <!-- 2) Escolher outro plano (amarelo Pro) -->
        <button
          @click="emit('change-plan')"
          type="button"
          class="w-full inline-flex items-center justify-center rounded-lg px-6 py-4 text-lg font-semibold bg-[#ffd6a5] text-[#6a4b1f] transition hover:bg-[#ffcf93]"
        >
          Escolher outro plano
        </button>

        <!-- 3) Ir para a página inicial (branco com borda) -->
        <button
          @click="emit('complete')"
          type="button"
          class="w-full inline-flex items-center justify-center rounded-lg px-6 py-4 text-lg font-semibold bg-surface text-[color:var(--text-dark)] border border-[color:var(--border-color)] transition hover:bg-[var(--bg-main)]"
        >
          Ir para a Página Inicial
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  result: {
    type: Object,
    required: true,
    validator: (v) =>
      typeof v.success === "boolean" && typeof v.message === "string",
  },
});

// inclui change-plan, usado pelo pai
const emit = defineEmits(["retry", "complete", "change-plan"]);
</script>
